"use client";

import { Notification } from "@/types/notification";
import NotificationItem, {
  NotificationAvatar,
  NotificationPageLink,
  NotificationWorkspaceLink,
} from "@/components/tailwind/notification/notificationItem";
import { useWorkspaceContext } from "@/contexts/workspaceContext";

interface NotificationPermissionChangedProps {
  notification: Notification;
}

export default function NotificationPermissionChanged({ notification }: NotificationPermissionChangedProps) {
  const { getMemberName } = useWorkspaceContext();
  const displayName = getMemberName(notification.createdBy?.userId) || getMemberName(notification.createdBy?.userEmail) || notification.createdBy?.userName || "An admin";

  return (
    <NotificationItem
      icon={<NotificationAvatar name={displayName} userId={notification.createdBy?.userId} email={notification.createdBy?.userEmail} />}
      createdAt={notification.createdAt}
      unread={!notification.read}
      title={displayName}
      message={
        <>
          Updated your access on{" "}
          <NotificationPageLink
            noteId={notification.noteId}
            title={notification.noteTitle}
          />{" "}
          in{" "}
          <NotificationWorkspaceLink
            workspaceId={notification.workspaceId}
            workspaceName={notification.workspaceName}
          />
        </>
      }
    />
  );
}
